import { createContext, useContext } from "react"

export const BoundContext = createContext({})

export function useBoundContext(additional = {}) {
    const context = useContext(BoundContext) ?? {}
    Object.assign(context, additional)
    return context
}
